import { render, staticRenderFns } from "./empdetail.vue?vue&type=template&id=d9b04ac2&"
import script from "./empdetail.vue?vue&type=script&lang=js&"
export * from "./empdetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports